import * as React from 'react';
import styled from 'styled-components';
import { Text } from '@oneaudi/unified-web-components';
import { renderTextWithFootnotesReferences } from '../../feature-service-types';

const DisclaimersContainer = styled.div`
  text-align: left;
`;

export interface DisclaimersProps {
  disclaimers?: string[];
}

export const Disclaimers: React.FC<DisclaimersProps> = ({ disclaimers }) => {
  if (!disclaimers || !disclaimers.length) return null;

  return (
    <DisclaimersContainer>
      {disclaimers?.map((disclaimer, i) => (
        <Text
          key={`disclaimer${i}`}
          variant={{
            type: 'copy',
            order: process.env.IS_LEGACY ? '2' : '3',
            style: 'normal',
          }}
        >
          {renderTextWithFootnotesReferences(disclaimer)}
        </Text>
      ))}
    </DisclaimersContainer>
  );
};

Disclaimers.displayName = 'Disclaimers';
